module.exports = "precision mediump float;\r\n\r\nvarying vec4 vFinalColor;\r\n\r\nvoid main(void) {\r\n  gl_FragColor = vFinalColor;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/gouraud/fragment-shader.glsl
// module id = 125
// module chunks = 0